import React, { useEffect, useState } from 'react'
import { Modal, View, Text, TouchableOpacity, StyleSheet, Platform } from 'react-native'
import { getPlatform as getPlatformUtils } from '../../../utils/platformUtils'
import styles from './CustomAlertStyles'
import { getLanguage } from '../../appBar/context/LocalizationContext'
import { Feather, Ionicons } from '@expo/vector-icons'
import { Loader, LoaderCustomAlert } from './Loader'
import { getData } from '../../appBar/context/HeaderContext'
import { useDataPendingSendStore } from '../../../redux/zustand/dataPendingSendStore'
import theme from '../../../../theme'
import { useAndroidNavBarHeight } from '../hooks/useAndroidNavBarHeight'

const CustomAlert = ({
    visible,
    backgroundColor,
    textColor,
    nameIcon,
    iconLibrary = 'Feather',
    iconSize = 20,
    message,
    onClose = null,
    buttonAdditional = null,
    secondMessage = null,
}) => {
    // const { languageFile } = getLanguage()
    const { isVisibleTabBar } = getData() || { isVisibleTabBar: true }
    const progress = useDataPendingSendStore((state) => state.progress)

    // Detectar si este es un alert de progreso basado en el mensaje
    // const isProgressAlert = message && (message.includes('%') || message.includes('Enviando')) // ROTOM-531
    const isProgressAlert = false // ROTOM-531

    // Función para renderizar el ícono según la librería especificada
    const renderIcon = (iconName, size, color, style = {}) => {
        if (!iconName) return null

        const iconProps = { name: iconName, size, color, style }

        switch (iconLibrary) {
            case 'Ionicons':
                return <Ionicons {...iconProps} />
            case 'Feather':
            default:
                return <Feather {...iconProps} />
        }
    }

    const handleClose = () => {
        if (onClose) {
            onClose() // Si se proporciona onClose, lo ejecutamos
        }
    }

    if (!visible) return null // Si no está visible, no renderizamos el modal
    const navBarHeight = useAndroidNavBarHeight()
    const getPlatform = () => {
        const platform = Platform.OS

        const platformMap = {
            ios: 0, //79
            android: 0, //49
            default: 0, // 79
        }
        return platformMap[platform] || platformMap.default
    }

    const buttomStyleAlert = isVisibleTabBar ? getPlatform() : 0
    const extraSpace = Platform.OS === 'android' // !isVisibleTabBar &&
    return (
        <View
            style={{
                position: 'absolute',
                bottom: buttomStyleAlert,
                paddingBottom: extraSpace ? navBarHeight : 0, //getPlatform() // Para que la alerta no se pise con los botones nativos de android
                left: 0,
                right: 0,
                zIndex: 2,
                flexDirection: 'column',
            }}
        >
            {/* Caja 1: Alert principal */}
            <View
                style={[
                    styles.modalView,
                    {
                        backgroundColor: backgroundColor,
                        position: 'relative',
                        bottom: 0,
                    },
                ]}
            >
                <View style={{ flex: 6, flexDirection: 'row', justifyContent: 'flex-start' }}>
                    {renderIcon(nameIcon, iconSize, textColor, [styles.alignSelf, { marginHorizontal: 12 }])}
                    <View style={{ flex: 1, marginRight: 15 }}>
                        <View style={{ flexDirection: 'row', alignContent: 'center', alignItems: 'center' }}>
                            <Text style={[styles.modalText, { fontWeight: 'normal', color: textColor, paddingVertical: 12 }]}>
                                {message}
                                {secondMessage && secondMessage != '' && (
                                    <Text style={[styles.modalText, { fontWeight: 'normal', color: textColor, paddingVertical: 12, marginLeft: 0 }]}>
                                        {` ${secondMessage}`}
                                    </Text>
                                )}
                            </Text>
                        </View>
                        {buttonAdditional && (
                            <TouchableOpacity
                                onPress={() => buttonAdditional.acction()}
                                style={{ flexDirection: 'row', marginBottom: 12, alignItems: 'center' }}
                            >
                                <Text style={[styles.modalText, { color: textColor, marginRight: 4 }]}>{buttonAdditional.text}</Text>
                                <Feather name='chevron-right' size={20} color={textColor} />
                            </TouchableOpacity>
                        )}
                    </View>
                </View>
                {onClose && (
                    <TouchableOpacity onPress={() => handleClose()} style={styles.containerOnClose}>
                        <View
                            style={[
                                styles.dividerVertical,
                                {
                                    borderColor: textColor,
                                    backgroundColor: textColor,
                                    height: buttonAdditional ? 94 : 62,
                                },
                            ]}
                        ></View>
                        <Feather name={'x'} size={24} color={textColor} />
                    </TouchableOpacity>
                )}
            </View>

            {isProgressAlert && progress > 0 && (
                <View
                    style={{
                        width: '100%',
                    }}
                >
                    <View
                        style={{
                            width: '100%',
                            height: 8,
                            backgroundColor: theme.colors.textSecondary,
                            overflow: 'hidden',
                        }}
                    >
                        <View
                            style={{
                                width: `${progress}%`,
                                height: '100%',
                                backgroundColor: theme.colors.colorPrimary,
                            }}
                        />
                    </View>
                </View>
            )}
        </View>
    )
}

export default CustomAlert
